import { render, staticRenderFns } from "./Aste.vue?vue&type=template&id=ef4bbc5c&scoped=true"
import script from "./Aste.vue?vue&type=script&lang=ts"
export * from "./Aste.vue?vue&type=script&lang=ts"
import style0 from "./Aste.vue?vue&type=style&index=0&id=ef4bbc5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4bbc5c",
  null
  
)

export default component.exports